module.exports = __webpack_public_path__ + "img/wall.024edfda.svg";